import React, { useState, useEffect } from "react";
import FileService from "../../services/file";
import LinearProgress from '@material-ui/core/LinearProgress';

const Upload = (props) => {
  const [progress, setPercentage] = useState(0);
  const [error, setError] = useState('');

  useEffect(()=>{
  })


  

  let uploadFile = (evt) => {
    if (document.getElementById(props.id).files[0]) {
      let foundFile = document.getElementById(props.id).files[0];
      setPercentage(1);
      FileService.uploadFile('https://aral.vedebo.net/documents/upload', foundFile, null, setPercentage)
        .then(
          (key) => {
            props.handleUploadedFile(key);
            document.getElementById(props.id).value = '';
            setPercentage(0);
          },
          (error) => {
            setError('Uw document kan niet worden verzonden naar de server. Controleer uw internetverbinding of probeer het op een later moment opnieuw.')
            document.getElementById(props.id).value = '';
            setPercentage(0);
          })
    }
  }

  return (
    <div>
      {progress !== 0
        &&
        <LinearProgress variant="determinate" value={progress} />
      }
      <div className="errorline">{error}</div>
      <input type="file" name={props.id} id={props.id} onChange={(e) => uploadFile(e)} style={{display:'none'}}/>
    </div>
  );
}

export default Upload;